<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    v-model="model.nome"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="form.programaTipos"
                    :validations="validations.programaTipo"
                    label="Tipo de programa"
                    show-default-option
                    text-field="nome"
                    v-model="model.programaTipoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :options="form.fornecimentoTipos"
                    :validations="validations.fornecimentoTipo"
                    label="Tipo de fornecimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.fornecimentoTipoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-select
                    :options="form.estruturasApoio"
                    :validations="validations.estruturaApoio"
                    label="Estrutura de apoio"
                    show-default-option
                    text-field="nome"
                    v-model="model.estruturaApoioId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-checkbox
                    :label="false"
                    inline
                    v-model="model.ativo"
                >
                    Ativo
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 300,
                },
                programaTipo: {
                    required: true,
                },
                fornecimentoTipo: {
                    required: true,
                },
                estruturaApoio: {
                    required: true,
                },
            }
        },
    },
    created() {
        this.repositories = {
            origemProgramatica: this.getConectaSusRepository('cadastro.origemProgramatica')
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.origemProgramatica.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

            } else {
                this.repositories.origemProgramatica.create()
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid) {
                        this.setLoading()

                        if (this.model.id) {
                            this.repositories.origemProgramatica.update(this.model.id, this.camelObjectKeysToSnakeRecursive(this.model))
                                .then(response => {
                                    this.showSaveNotification()
                                    this.$emit('save', response)
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        } else {
                            this.repositories.origemProgramatica.store(this.camelObjectKeysToSnakeRecursive(this.model))
                                .then(response => {
                                    this.showSaveNotification()
                                    this.$emit('save', response)
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        }
                    }
                })
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: [Number, String], default: null},
    },
}
</script>